import loadable from '@loadable/component';

// Non-Lazy Page Components
import HomePage from '/views/pages/home';
import PlaceOrderPage from '/views/pages/place-order';
import MenuPage from '/views/pages/menu';
import BasketPage from '/views/pages/basket';
import LoginPage from '/views/pages/login';

export default {
	home: {
		path: '/',
		exact: true,
		layout: 'raw',
		layoutClass: 'home',
		component: HomePage,
	},
	webLanding: {
		path: '/navigasyon',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-landing',
		allowWeb: true,
		disallowApp: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-landing')),
	},
	placeOrder: {
		path: '/siparis-ver',
		exact: true,
		layout: 'raw',
		layoutClass: 'place-order',
		component: PlaceOrderPage,
	},
	menu: {
		path: '/mobil-menu',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu',
		component: MenuPage,
	},
	menuCategory: {
		path: '/mobil-menu/kategori/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-category',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-category')),
	},
	menuSearch: {
		path: '/mobil-menu/arama/:query?',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-search',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-search')),
	},
	menuProduct: {
		path: '/mobil-menu/urun/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-product',
		hideNav: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-product')),
	},
	webMenu: {
		path: '/menu/:branchSlug/:tableId?',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu')),
	},
	webMenuDisplayed: {
		path: '/menu/kategori/goster/:branchSlug/:tableId?',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu')),
	},
	webMenuCategory: {
		path: '/menu/:branchSlug/kategori/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu-category',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu-category')),
	},
	webMenuProduct: {
		path: '/menu/:branchSlug/urun/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu-product',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu-product')),
	},
	promotions: {
		path: '/promosyonlar/:type?',
		exact: true,
		layout: 'raw',
		layoutClass: 'promotions',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/promotions')),
	},
	basket: {
		path: '/sepet',
		exact: true,
		layout: 'raw',
		layoutClass: 'basket',
		hideNav: true,
		component: BasketPage,
	},
	payment: {
		path: '/sepet/odeme/:orderId',
		requiresLogin: true,
		exact: true,
		layout: 'raw',
		layoutClass: 'payment',
		hideNav: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/payment')),
	},
	orderSummary: {
		path: '/sepet/odeme/basarili/:orderId',
		requiresLogin: true,
		exact: true,
		layout: 'raw',
		layoutClass: 'order-summary',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/order-summary')),
	},
	login: {
		path: '/giris-yap',
		exact: true,
		layout: 'raw',
		layoutClass: 'login',
		hideNav: true,
		component: LoginPage,
	},
	account: {
		path: '/hesabim',
		requiresLogin: true,
		redirect: {
			key: 'account.nav',
			params: {},
		},
		children: {
			nav: {
				path: '/hesabim/menu',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-nav',
				requiresLogin: true,
				component: loadable(() => import('/views/pages/account/nav')),
			},
			info: {
				path: '/hesabim/bilgilerim',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-info',
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/info')),
			},
			paymentMethods: {
				path: '/hesabim/odeme-yontemleri',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-payment-methods',
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/payment-methods')),
			},
			orders: {
				path: '/hesabim/gecmis-siparisler',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-orders',
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/orders')),
			},
			orderDetail: {
				path: '/hesabim/gecmis-siparisler/:id',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-order-detail',
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/order-detail')),
			},
		},
	},
	dataRemoval: {
		path: '/veri-silme-talebi',
		exact: true,
		layout: 'raw',
		layoutClass: 'data-removal',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: false */ '/views/pages/data-removal')),
	},
	notFound: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-not-found',
		status: 404,
		head: {
			title: 'Sayfa Bulunamadı',
		},
		component: loadable(() => import('/views/pages/not-found')),
	},
	error: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-error',
		status: 500,
		head: {
			title: 'Bir Hata İle Karşılaşıldı',
		},
		component: loadable(() => import('/views/pages/error')),
	},
};
